import {createUseStyles} from "react-jss";
import {colors} from "../../constants/colors";
import checkIconRed from "../../resources/images/alert-circle.svg";

const styles = createUseStyles({
  container: {
    width: '100%',
    minHeight: '48px',
    border: `1px solid ${colors.darkGrey}`,
    borderRadius: '8px',
    padding: '8px 12px',
    cursor: 'text',
    '&:focus-within': {
      outline: 'none',
    }
  },
  valuesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'center',
    minHeight: '32px',
  },
  valueTag: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: colors.white,
    border: `1px solid ${colors.darkGrey}`,
    borderRadius: '6px',
    padding: '2px 4px 2px 9px',
    fontSize: '14px',
    gap: '6px',
  },
  valueText: {
    lineHeight: 1.4,
    whiteSpace: 'nowrap',
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "400",
    color: colors.grey,
  },
  removeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '2px',
    borderRadius: '50%',
    width: '16px',
    height: '16px',
    '&:hover': {
      backgroundColor: colors.darkGrey,
    },
    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.5,
    },
    "&:focus-visible":{
      outline: "2px solid " + colors.black,
    },
  },
  closeIcon: {
    width: '12px',
    height: '12px',
  },
  maxMessage: {
    marginTop: "4px",
    fontSize: '14px',
    color: colors.black,
    "&:focus-visible":{
      outline: "none",
    },
  },
  errorContainer: {
    border: `1px solid ${colors.mediumRed}`,
    '&:focus-within': {
      borderColor: colors.mediumRed,
      outline: 'none',
    },
    backgroundSize: "16px 16px",
    backgroundPosition: "right",
    backgroundRepeat: "no-repeat",
    backgroundOrigin: "content-box",
    backgroundImage: `url(${checkIconRed})`
  },
  errorBorder: {
    border: `1px solid ${colors.mediumRed}`,
  },
  errorText: {
    color: colors.red
  },
  errorIcon: {
    "& path": {
      stroke: colors.mediumRed,
    },
  },
  addInput: {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    fontSize: '14px',
    flex: 1,
    minWidth: '120px',
    padding: '6px 0',
    '&:disabled': {
      cursor: 'not-allowed',
    }
  },
});

export default styles;